import * as React from 'react';
import { ExpandableSection, Title } from '@patternfly/react-core';
import ErrorState from '../ErrorState';
import ErrorStack from '../ErrorStack';
// As of time of writing, React only supports error boundaries in class components
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.updateState = () => {
            if (this.state.historyState !== history.state) {
                this.setState({
                    hasError: false,
                    historyState: history.state,
                });
            }
        };
        this.state = {
            hasError: false,
            historyState: history.state,
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error, historyState: history.state };
    }
    componentDidUpdate() {
        this.updateState();
    }
    componentDidMount() {
        this.updateState();
    }
    render() {
        if (this.state.hasError) {
            if (this.props.silent) {
                return null;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(Title, { headingLevel: "h1", size: "2xl" }, this.props.headerTitle),
                React.createElement(ErrorState, { errorTitle: this.props.errorTitle, errorDescription: React.createElement(React.Fragment, null,
                        React.createElement("span", null, this.props.errorDescription),
                        this.state.error && (React.createElement(ExpandableSection, { toggleText: this.props.errorToggleText ? this.props.errorToggleText : "Show details" },
                            React.createElement(ErrorStack, { error: this.state.error })))), defaultErrorDescription: this.props.defaultErrorDescription })));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
